import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "./SendReportSummaryModal.css";

export default function SendReportSummaryModal({
  uploadedAndSent = [],
  failed = [],
  toggleModal,
}) {
  // Extract filename from s3_url (same logic as used in the codebase)
  const extractFileName = (s3Url) => {
    if (!s3Url) return "";
    const pathParts = s3Url.split("/");
    return pathParts[pathParts.length - 1];
  };

  // Determine response type based on data
  const hasFailures = failed && failed.length > 0;
  const hasSuccess = uploadedAndSent && uploadedAndSent.length > 0;
  const isCompleteSuccess = !hasFailures && hasSuccess;

  const renderSuccessOnlyMessage = () => (
    <div className="SendReportSummaryModal__SuccessMessage">
      <div className="SendReportSummaryModal__SuccessIcon">
        <i className="fa fa-check-circle" />
      </div>
      <div className="SendReportSummaryModal__SuccessText">
        Reports Sent Successfully!
      </div>
    </div>
  );

  const renderDetailedSummary = () => (
    <div className="SendReportSummaryModal__SummaryContainer">
      <div className="SendReportSummaryModal__SummaryHeader">
        <div className="SendReportSummaryModal__SummaryTitle">
          Send Report Summary
        </div>
      </div>

      <div className="SendReportSummaryModal__SummaryContent">
        {/* Success Column */}
        <div className="SendReportSummaryModal__Column">
          <div className="SendReportSummaryModal__ColumnHeader SuccessHeader">
            <i className="fa fa-check-circle" />
            <span>
              Sent Successfully (
              {uploadedAndSent.length}
              )
            </span>
          </div>
          <div className="SendReportSummaryModal__ColumnContent">
            <div className="SendReportSummaryModal__ScrollContainer">
              {hasSuccess ? (
                uploadedAndSent.map((item, index) => (
                  <div key={index} className="SendReportSummaryModal__Item SuccessItem">
                    <div className="SendReportSummaryModal__FileName">
                      {extractFileName(item.s3_url)}
                    </div>
                  </div>
                ))
              ) : (
                <div className="SendReportSummaryModal__Item">
                  <div className="SendReportSummaryModal__FileName SendReportSummaryModal__EmptyMessage">
                    No reports sent successfully
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Failure Column */}
        <div className="SendReportSummaryModal__Column">
          <div className="SendReportSummaryModal__ColumnHeader FailureHeader">
            <i className="fa fa-exclamation-circle" />
            <span>
              Failed to Send (
              {failed.length}
              )
            </span>
          </div>
          <div className="SendReportSummaryModal__ColumnContent">
            <div className="SendReportSummaryModal__ScrollContainer">
              {hasFailures ? (
                failed.map((item, index) => (
                  <div key={index} className="SendReportSummaryModal__Item FailureItem">
                    <div className="SendReportSummaryModal__FileName">
                      {extractFileName(item.s3_url)}
                    </div>
                    <div className="SendReportSummaryModal__FailureReason">
                      {"Reason: "}
                      {" "}
                      {item.message || "Unknown error"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="SendReportSummaryModal__Item">
                  <div className="SendReportSummaryModal__FileName SendReportSummaryModal__EmptyMessage">
                    No reports failed
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <SweetAlert
      customClass="SendReportSummaryModal__SweetAlert"
      title=""
      showConfirm={false}
      onConfirm={() => {}}
    >
      <div className="SendReportSummaryModal__Container">
        {isCompleteSuccess ? renderSuccessOnlyMessage() : renderDetailedSummary()}

        <div className={`SendReportSummaryModal__Footer ${isCompleteSuccess ? "SendReportSummaryModal__Footer--centered" : "SendReportSummaryModal__Footer--right"}`}>
          <button
            type="button"
            className="SendReportSummaryModal__CloseBtn"
            onClick={toggleModal}
          >
            Close
          </button>
        </div>
      </div>
    </SweetAlert>
  );
}
